// extracted by mini-css-extract-plugin
export default {"scroll":"Buildings_scroll__HGCU-","building_name_wrapper":"Buildings_building_name_wrapper__dFcZU"};